<template>
  <TheLayout :showHomeLink="showHomeLink">
    <div class="card text-center">
      <div class="card-header bg-white">
        <img class="img-fluid" src="/mobilfunkrauchmelder.jpg" alt="PROEinsatz" width="300">
        <h1>PROEinsatz Mobilfunk-Rauchmelder</h1>
        <h2>{{ detector?.identifier }}</h2>
        <h3>Dieses Gerät ist ein Mietgerät.</h3>
        <p>
          Kontakt zum Vertrieb: <a href="mailto:vertrieb@proeinsatz.de">vertrieb@proeinsatz.de</a><br>
          Kontakt zum technischen Support: <a href="mailto:support@proeinsatz.com">support@proeinsatz.com</a>
        </p>
      </div>
      <div class="card-body">
        <div v-if="detector">
          <table class="table table-responsive">
            <tbody>
            <tr>
              <th class="col-6" scope="row">Beschreibung:</th>
              <td class="col-6">{{ detector?.DESCRIPTION }}</td>
            </tr>
            <tr>
              <th scope="row">Status:</th>
              <td>{{ currentStateFormated }}</td>
            </tr>
            <tr>
              <th scope="row">L. Update:</th>
              <td>{{ lastUpdateFormated }}</td>
            </tr>
            <tr>
              <th scope="row">L. Kontakt:</th>
              <td>{{ lastContactFormated }}</td>
            </tr>
            <tr>
              <th scope="row">L. Kontakt Status:</th>
              <td>{{ detector?.LastContactState }}</td>
            </tr>
            <tr>
              <th scope="row">Signal Level:</th>
              <td>{{ detector?.SignalLevel }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <div class="alert alert-danger" role="alert">
            Melder nicht gefunden.
          </div>
        </div>
      </div>
      <div class="card-footer">
        <router-link v-if="showHomeLink" :to="{ name: 'Home' }">
          <button class="btn btn-secondary my-4">Zurück zur Übersicht</button><br>
        </router-link>
        <a href="https://www.proeinsatz.de/impressum" target="_blank">Impressum</a>
      </div>
    </div>
  </TheLayout>
</template>


<script setup>
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import {computed, onMounted, ref} from "vue";
import { formatDate, formatState } from "@/utils/format";
import TheLayout from "@/layouts/TheLayout.vue";

const route = useRoute();

const store = useStore();

const detector = ref(null);

const lastUpdateFormated = computed(() => detector?.value ? computed(() => formatDate(detector.value.LastUpdate)) : '');
const lastContactFormated = computed(() => detector?.value ? computed(() => formatDate(detector.value.LastContact)): '');
const currentStateFormated = computed(() => detector?.value ? computed(() => formatState(detector.value.currentstate)) : '');

const showHomeLink = computed(() => route.query.showHomeLink === "1");

onMounted(async () => {
  detector.value = await store.dispatch("getDeviceInfo", route.params.deviceId ?? null);
});

</script>

<style scoped>

  table tr th {
    text-align: right;
  }

  table tr td {
    text-align: left;
  }

</style>